export default __webpack_public_path__ + "static/media/card2.1206af48.png";